module.exports = __webpack_public_path__ + "static/media/svg.4a96967e.svg";